<script setup lang="ts">
import { RouterView } from 'vue-router';
import AppSidebar from '@/components/shell/AppSidebar.vue';
import AppTopbar from '@/components/shell/AppTopbar.vue';
import SidebarBackdrop from '@/components/shell/SidebarBackdrop.vue';
import { useSidebarDrawer } from '@/composables/useSidebarDrawer';
import { useIssuesSignalR } from '@/composables/useIssuesSignalR';
import { useSignalRDashboard } from '@/composables/useSignalRDashboard';

const { isOpen, toggle, close } = useSidebarDrawer();

// Mount issues SignalR + dashboard SignalR at the layout level so they
// survive list↔detail navigation. After Task 13's refactor the dashboard
// hub is a singleton; useNavCounts (sidebar badges) subscribes to the same
// summaryInvalidated event via onDashboardInvalidated.
useIssuesSignalR();
useSignalRDashboard();
</script>

<template>
  <div class="min-h-screen bg-canvas lg:grid lg:grid-cols-[var(--spacing-sidebar)_1fr]">
    <AppSidebar :open="isOpen" />
    <SidebarBackdrop :open="isOpen" @close="close" />

    <div class="flex flex-col min-w-0">
      <AppTopbar @toggle-drawer="toggle" />
      <main class="flex-1 p-4 md:p-6 lg:p-8 max-w-[1440px] w-full mx-auto">
        <RouterView />
      </main>
    </div>
  </div>
</template>
